import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { AdminWalletHistoryRow } from "./row";

import { SvgAttribute } from "@/shared/constants/constants";
import {
  AdminWalletHistoryTableHeaders,
  AdminWalletHistoryTableHeader,
} from "@/data/admin/wallet/historyTable";
import { Search, Sort } from "@/shared/constants/interfaces";
// import { SearchType } from "@/shared/constants/enums";
import { AdminWalletHistoryResponse } from "@/shared/repository/modules/wallet/repo";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    AdminWalletHistoryRow,
  },
  props: {
    search: {
      type: <PropType<Search>>Object,
      required: true,
    },
    sort: {
      type: <PropType<Sort>>Object,
      required: true,
    },
    history: {
      type: <PropType<AdminWalletHistoryResponse[]>>Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    displayedIcons(): SvgAttribute {
      return SVG;
    },

    displayedColumns(): AdminWalletHistoryTableHeader[] {
      return AdminWalletHistoryTableHeaders;
    },
  },
});
